export enum ReportReason {
  INAPPROPRIATE_CONTENT = 'INAPPROPRIATE_CONTENT',
  INCORRECT_CONTENT = 'INCORRECT_CONTENT',
  FRAUDULENT_CONTENT = 'FRAUDULENT_CONTENT',
  OTHER = 'OTHER',
}